import { render, staticRenderFns } from "./detailCurrent.vue?vue&type=template&id=65d42b14&scoped=true"
import script from "./detailCurrent.vue?vue&type=script&lang=js"
export * from "./detailCurrent.vue?vue&type=script&lang=js"
import style0 from "./detailCurrent.vue?vue&type=style&index=0&id=65d42b14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d42b14",
  null
  
)

export default component.exports